export default "__VITE_ASSET__CNWRxXcS__"